<script lang="ts">
    interface Props {
        sponsored: boolean;
        funderLegalName: string;
        advertiserLegalName: string;
        linkVariant?: 'secondary' | 'inverted';
    }

    let { sponsored, funderLegalName, advertiserLegalName, linkVariant = 'secondary' }: Props = $props();
</script>

{#if sponsored}
    <oc-link-v2
        icon-right="info-hint"
        variant={linkVariant}
        class="oc-pb-25"
        size={'75'}
        as-button={true}
        data-oc-sheet-v1-open
        data-oc-sheet-v1-open.id="reptile-sponsored-product-sheet"
        data-oc-sheet-v1-open.extra-data={JSON.stringify({ advertiserLegalName, funderLegalName })}
        >gesponsert
    </oc-link-v2>
{/if}
